import React, { Suspense, useEffect, useMemo, useRef } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_GROUP_BY_DATA,
  GET_SUB_TAG_DATA,
  DEFAULT,
  secondDropdownValues,
  GET_CVE_LIST_BY_SEVERITY,
} from "./NetSpaceConstant";
import { sourceNameMap } from "./NetSpaceUtils";

const useAccordionStyles = makeStyles({
  accordionSummary: {
    flexDirection: "row-reverse",
    backgroundColor: "#47856d",
    color: "white",
  },
  accordionDetails: {
    height: "500px",
    overflowY: "auto",
  },
});

const LazyAccordion = ({
  label,
  count,
  groupKey,
  isExpanded,
  onToggle,
  LazyComponent,
  lazyProps = {},
}) => {
  const classes = useAccordionStyles();

  return (
    <Accordion expanded={isExpanded} onChange={() => onToggle(groupKey)}>
      <AccordionSummary
        className={classes.accordionSummary}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography>
          {sourceNameMap[label] || label} ({count})
        </Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.accordionDetails}>
        <Suspense fallback={<div>Loading table...</div>}>
          {isExpanded && <LazyComponent group={groupKey} {...lazyProps} />}
        </Suspense>
      </AccordionDetails>
    </Accordion>
  );
};

export default LazyAccordion;
